import { track } from '../../vendor/splitmetrics-track/index';



export const EVENT_NAME = 'apple_watch_gallery_slide_open';


export default (params) => {
  track(EVENT_NAME, params, {});
};



// WEBPACK FOOTER //
// ./src/lib/track-event/apple-watch-gallery-slide-open.js